import PasswordNameField from "./PasswordNameField.vue";
import NameField from "./NameField.vue";
import CodeCompanyField from "./CodeCompanyField.vue";

export { PasswordNameField, NameField, CodeCompanyField };
